import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ChatProvider } from './context/ChatContext';
import Setup from './pages/Setup';
import Search from './pages/Search';
import Chat from './pages/Chat';
import Admin from './pages/Admin';

const App = () => {
  return (
    <ChatProvider>
      <div style={{ padding: '0 10px', background: '#f0f2f5', minHeight: '100vh' }}>
        <Routes>
          <Route path="/" element={<Setup />} />
          <Route path="/search" element={<Search />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </div>
    </ChatProvider>
  );
};

export default App;
